import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Tooltip, Progress } from 'antd';
import { getTasksSummary } from 'ACTIONS/resources.actions';
import './Summary.less';

class Summary extends Component {
  componentDidMount() {
    const { resource, resourceTypeId } = this.props;
    this.props.getTasksSummary(resource, resourceTypeId);
  }
  render() {
    const { summary, lastUpdateMessage } = this.props;
    const {
      isLoaded,
      lastUpdate,
      statuses,
    } = summary;

    const total = Object.keys(statuses).reduce((sum, next) => sum + statuses[next], 0);
    const lastUpdateDone = Object.prototype.hasOwnProperty.call(lastUpdate, 'done') ? lastUpdate.done : null;
    const { done, failed } = statuses;

    const percent = Math.round(((done + failed) / total) * 100);
    const successPercent = (done / total) * 100;
    const todo = total - (done + failed);
    if (!isLoaded || !total) {
      return null;
    }

    return (
      <div className="summary">
        <Tooltip placement="topLeft" title={`${done} Done / ${failed} Failed / ${todo} Pending`}>
          <Progress percent={percent} successPercent={successPercent} status={done ? null : 'exception'} />
        </Tooltip>
        <p className="summary-text">{(lastUpdateDone) && `${lastUpdateMessage} ${moment(lastUpdateDone).format('LLLL')}`}</p>
      </div>
    );
  }
}

Summary.defaultProps = {
  lastUpdateMessage: '',
  summary: {
    total: 0,
    done: 0,
    lastUpdate: {},
    isLoaded: false,
    statuses: {
      started: 0,
      done: 0,
      failed: 0,
      success: 0,
      queued: 0,
    },
  },
};

Summary.propTypes = {
  getTasksSummary: PropTypes.func.isRequired,
  lastUpdateMessage: PropTypes.string,
  summary: PropTypes.shape({
    total: PropTypes.number,
    done: PropTypes.number,
    lastUpdate: PropTypes.object,
    isLoaded: PropTypes.bool,
    statuses: PropTypes.shape({
      started: PropTypes.number,
      done: PropTypes.number,
      failed: PropTypes.number,
      success: PropTypes.number,
      queued: PropTypes.number,
    }),
  }),
  resource: PropTypes.string.isRequired,
  resourceTypeId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
};

const mapStateToProps = ({ resources }, props) => ({
  summary: resources[props.resource].summary,
});

export default connect(mapStateToProps, { getTasksSummary })(Summary);



// WEBPACK FOOTER //
// ./src/pages/Control/Summary/Summary.js